import { Logger } from '@/shared/logger/logger';

import { SESSION_ID_KEY } from '../constants';

const createHiddenInput = (id: string, value: string): HTMLInputElement => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(
    `<input id="${id}" type="hidden" name="properties[${id}]" value="${value}"/>`,
    'text/html',
  );
  // eslint-disable-next-line unicorn/prefer-query-selector
  return doc.getElementById(id) as HTMLInputElement;
};

const addCSSRule = (document: Document, css: string) => {
  const style = document.createElement('style');
  style.setAttribute('type', 'text/css');
  style.append(document.createTextNode(css));
  document.head.append(style);
};

export const injectSessionIdInLineItems = (
  sessionId: string,
  SessionIdKey: string = SESSION_ID_KEY,
) => {
  const maybeProductForm = document.querySelectorAll<HTMLFormElement>(
    '[action="/cart/add"], [action*="cart"], [action="/cart/add.js"], [data-zp-add-to-cart-form]',
  );

  if (maybeProductForm.length === 0) return;
  // Add CSS rule to make the hidden input element invisible
  addCSSRule(document, `#${SessionIdKey} { display: none; }`);

  maybeProductForm.forEach(form => {
    if (form) {
      const ssnIdInputEl = createHiddenInput(SessionIdKey, sessionId);

      try {
        form.append(ssnIdInputEl);
      } catch (error) {
        Logger.error('Error in Injecting LineItems', error);
      }
    } else {
      Logger.error('Error: Form not found');
    }
  });
};
